import axiosInstance from "../axios.service"
import BaseUrl from "../url.service"

const serverUrl = `${BaseUrl}/bannerImage`

// Get all slots for admin management
export const getAdminSlotsForManagementApi = () => {
  return axiosInstance.get(`${BaseUrl}/adSlots/admin-management`)
}

// Get all web advertisement data
export const getWebAdvertisementApi = () => {
  return axiosInstance.get(`${serverUrl}/ads`)
}

// Get web advertisement data by ID
export const getWebAdvertisementByIdApi = (id) => {
  return axiosInstance.get(`${serverUrl}/ad/${id}`)
}

// Add or update web advertisement data
export const addOrUpdateWebAdvertisementApi = (formData) => {
  return axiosInstance.post(`${serverUrl}/ad-edit`, formData)
}

// Get pending advertisements (admin only)
export const getPendingAdsApi = () => {
  return axiosInstance.get(`${serverUrl}/ads/pending`)
}

// Approve advertisement (admin only)
export const approveAdApi = (sectionId, adImage) => {
  return axiosInstance.put(`${serverUrl}/ads/approve`, { sectionId, adImage })
}

// Reject advertisement (admin only)
export const rejectAdApi = (sectionId, adImage) => {
  return axiosInstance.delete(`${serverUrl}/ads/reject`, { data: { sectionId, adImage } })
}

// Update ad metadata (order, keywords) - admin only
export const updateAdMetadataApi = (updates) => {
  return axiosInstance.put(`${serverUrl}/ads/update-metadata`, updates)
}

// Get vendor's purchased slots for management
export const getVendorSlotsForManagementApi = () => {
  return axiosInstance.get(`${BaseUrl}/adSlots/vendor-management`)
}

// Upload ad content to a specific slot
export const uploadAdToSlotApi = (slotId, formData) => {
  return axiosInstance.patch(`${BaseUrl}/adSlots/${slotId}/uploadAd`, formData)
}

// Combined service for all web advertisement operations
const webAdvertisementService = {
  getWebAdvertisement: getWebAdvertisementApi,
  getWebAdvertisementById: getWebAdvertisementByIdApi,
  addOrUpdateWebAdvertisement: addOrUpdateWebAdvertisementApi,
  getPendingAds: getPendingAdsApi,
  approveAd: approveAdApi,
  rejectAd: rejectAdApi,
  updateAdMetadata: updateAdMetadataApi,
  getVendorSlotsForManagement: getVendorSlotsForManagementApi,
  getAdminSlotsForManagement: getAdminSlotsForManagementApi,
  uploadAdToSlot: uploadAdToSlotApi
}

export default webAdvertisementService

